import i18next from 'i18next';

import { useTimeComposable } from '@/composables';
import type { Charts } from '@/helpers/interfaces/admin/chart.inteface';
const { t } = i18next;

const useReduceChartData = () => {
  const { useDateTime } = useTimeComposable();
  const useChartData = (dataGraphData: Charts) => {
    const chartDataObject = dataGraphData;
    if (Object.entries(chartDataObject).length <= 10) {
      const chartData = Object.entries(chartDataObject).reduce(
        (
          acc: {
            [key: string]: {
              date: string;
              growth: number;
            };
          },
          [date, growth]
        ) => {
          const currentDate = new Date(date);
          const formattedDate = useDateTime(
            currentDate,
            {
              year: undefined,
              month: 'short',
              day: '2-digit',
            },
            true
          );

          if (!acc[formattedDate]) {
            acc[formattedDate] = {
              date: formattedDate,
              growth: 0,
            };
          }
          acc[formattedDate].growth += growth ? growth : 0;
          return acc;
        },
        {}
      );
      return {
        data: Object.values(chartData),
      };
    } else if (Object.entries(chartDataObject).length < 60) {
      let weekIndex = 0;
      const chartData = Object.entries(chartDataObject).reduce(
        (
          acc: {
            [key: string]: {
              date: string;
              growth: number;
            };
          },
          [date, growth]
        ) => {
          //to obtain the month by name
          const formattedDate = useDateTime(
            date,
            {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
            },
            true
          );

          const startWeek = new Date(formattedDate);
          startWeek.setDate(startWeek.getDate() - startWeek.getDay());
          const weekKey = startWeek.toDateString();
          if (!acc[weekKey]) {
            weekIndex++;
            acc[weekKey] = {
              date: `${t('adminDashboard.week')} ${weekIndex} `,
              growth: 0,
            };
          }
          acc[weekKey].growth += growth ? growth : 0;
          return acc;
        },
        {}
      );

      return {
        data: Object.values(chartData),
      };
    } else if (Object.entries(chartDataObject).length <= 365) {
      const chartData = Object.entries(chartDataObject).reduce(
        (
          acc: {
            [key: string]: {
              date: string;
              growth: number;
            };
          },
          [date, growth]
        ) => {
          const monthName = new Date(date).toLocaleString('default', {
            month: 'short',
          });

          const formattedDate = monthName;
          if (!acc[formattedDate]) {
            acc[formattedDate] = {
              date: formattedDate,
              growth: 0,
            };
          }
          acc[formattedDate].growth += growth ? growth : 0;
          return acc;
        },
        {}
      );
      return {
        data: Object.values(chartData),
      };
    } else {
      const chartData = Object.entries(chartDataObject).reduce(
        (
          acc: {
            [key: string]: {
              date: number;
              growth: number;
            };
          },
          [date, growth]
        ) => {
          const year = new Date(date).getFullYear();

          if (!acc[year]) {
            acc[year] = {
              date: year,
              growth: 0,
            };
          }
          acc[year].growth += growth ? growth : 0;
          return acc;
        },
        {}
      );
      return {
        data: Object.values(chartData),
      };
    }
  };
  //this for userActivityChart chart
  const useUserActivityData = (dataGraphData: Charts) => {
    const chartDataObject = dataGraphData;

    if (Object.entries(chartDataObject).length <= 10) {
      const chartData = Object.entries(chartDataObject).reduce(
        (
          acc: {
            [key: string]: {
              date: string;
              growth: number;
            };
          },
          [date, growth]
        ) => {
          const currentDate = new Date(date);
          const formattedDate = useDateTime(
            currentDate,
            {
              year: 'numeric',
              month: 'short',
              day: '2-digit',
            },
            true
          );

          if (!acc[formattedDate]) {
            acc[formattedDate] = {
              date: formattedDate,
              growth: 0,
            };
          }
          acc[formattedDate].growth = growth ? growth : 0;
          return acc;
        },
        {}
      );

      return {
        data: Object.values(chartData),
      };
    }
    if (Object.entries(chartDataObject).length < 60) {
      let weekIndex = 0; // Initialize the week index
      const chartData = Object.entries(chartDataObject).reduce(
        (
          acc: {
            [key: string]: {
              date: string;
              growth: number;
            };
          },
          [date, growth]
        ) => {
          //to optain the month by name
          const formattedDate = useDateTime(
            date,
            {
              year: 'numeric',
              month: 'short',
              day: '2-digit',
            },
            true
          );

          const startWeek = new Date(formattedDate);
          startWeek.setDate(startWeek.getDate() - startWeek.getDay());
          const weekKey = startWeek.toDateString();
          if (!acc[weekKey]) {
            weekIndex++;

            acc[weekKey] = {
              date: `${t('adminDashboard.week')} ${weekIndex} `,
              growth: 0,
            };
          }
          acc[weekKey].growth += growth ? growth : 0;
          return acc;
        },
        {}
      );

      return {
        data: Object.values(chartData),
      };
    }
    if (Object.entries(chartDataObject).length <= 365) {
      const chartData = Object.entries(chartDataObject).reduce(
        (
          acc: {
            [key: string]: {
              date: string;
              growth: number;
            };
          },
          [date, growth]
        ) => {
          const monthName = new Date(date).toLocaleString('default', {
            month: 'short',
          });

          const formattedDate = monthName;
          if (!acc[formattedDate]) {
            acc[formattedDate] = {
              date: formattedDate,
              growth: 0,
            };
          }
          acc[formattedDate].growth += growth ? growth : 0;
          return acc;
        },
        {}
      );
      return {
        data: Object.values(chartData),
      };
    } else {
      const chartData = Object.entries(chartDataObject).reduce(
        (
          acc: {
            [key: string]: {
              date: number;
              growth: number;
            };
          },
          [date, growth]
        ) => {
          const year = new Date(date).getFullYear();

          if (!acc[year]) {
            acc[year] = {
              date: year,
              growth: 0,
            };
          }
          acc[year].growth += growth ? growth : 0;
          return acc;
        },
        {}
      );
      return {
        data: Object.values(chartData),
      };
    }
  };
  return { useChartData, useUserActivityData };
};
export default useReduceChartData;
